export default __webpack_public_path__ + "static/media/asset-details.7c801107.svg";